<template>
    <div>
        <LoadingSpinner class="page-loading" :isLoading="isLoading" />
    </div>

    <div class="container-fluid">
        <header class="main-header main-header-container">
            <h1 v-if="material.equipmentGroup == equipmentGroup.Equipment" class="main-title">Noodmaterieel detail</h1>
            <h1 v-if="material.equipmentGroup == equipmentGroup.Material" class="main-title">Noodmateriaal detail</h1>
        </header>

        <form @submit.prevent="formSubmit">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <div class="top-bar">
                                <h5>Algemeen</h5>
                                <div v-if="hasFeature('QrCodes')">
                                    <img v-if="!this.material.qr" src="@/assets/img/qr-loading.png" class="qr-code"
                                        alt="qr-code" />
                                    <img v-else v-bind:src="this.material.qr" class="qr-code" alt="qr-code" />
                                </div>
                            </div>
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <label for="typeId">
                                        Materiaal type
                                        <span class="required">*</span>
                                    </label>

                                    <select id="typeId" class="form-select" name="typeId" v-model="material.typeId">
                                        <option :value="material.typeId" disabled>
                                            {{ material.typeName || 'Kies type' }}
                                        </option>
                                        <option v-for="equipmentType in equipmentTypes" :key="equipmentType.id"
                                            :value="equipmentType.id">
                                            {{ equipmentType.name }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <div v-if="errors.TypeId">{{ errors.TypeId.join(', \n') }}</div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label for="status">
                                        Status
                                        <span class="required">*</span>
                                    </label>
                                    <select id="status" class="form-select" name="status" v-model="material.status">
                                        <option :value="material.status" disabled>
                                            {{ getStatusText(material.status) || 'Kies status' }}
                                        </option>
                                        <option :value="status.Available">Beschikbaar</option>
                                        <option :value="status.InUse">Bezet</option>
                                        <option :value="status.Faulty">Defect</option>
                                        <option :value="status.InTransit">Onderweg</option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label for="usedByUserId">Onder naam van</label>
                                    <select id="usedByUserId" class="form-select" name="usedByUserId"
                                        v-model="material.usedByUserId">
                                        <option :value="-1">Niet onder naam</option>
                                        <option v-for="user in this.allUsers" :key="user.userId" :value="user.userId">
                                            {{ user.userName }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label for="currentLocationId">
                                        Huidige locatie
                                        <span class="required">*</span>
                                    </label>
                                    <div class="flex-box">
                                        <div class="flex-stretch">
                                            <select v-if="this.chosenLocationType == locationType.locationId"
                                                id="currentLocationId" class="form-select" name="currentLocationId"
                                                v-model="material.currentLocationId">
                                                <option :value="null" disabled>Kies een locatie</option>
                                                <option v-for="location in locations" :key="location.id"
                                                    :value="location.id"
                                                    :disabled="location.id == this.material.currentLocationId">
                                                    {{ location.name }}
                                                </option>
                                            </select>

                                            <input v-if="this.chosenLocationType == locationType.locationString"
                                                id="currentLocationString" type="text" class="form-control"
                                                name="currentLocationString" v-model="material.currentLocationString" />
                                            <div class="flex-box">
                                                <input v-if="this.chosenLocationType == locationType.coordinates"
                                                    id="latitude" type="text" class="form-control" name="latitude"
                                                    v-model="material.latitude" />
                                                <input v-if="this.chosenLocationType == locationType.coordinates"
                                                    id="longitude" type="text" class="form-control" name="longitude"
                                                    v-model="material.longitude" />
                                            </div>

                                        </div>
                                        <div>
                                            <select id="chosenLocationType" class="form-select"
                                                name="chosenLocationType" v-model="chosenLocationType">
                                                <option :value="locationType.locationId">Depot</option>
                                                <option :value="locationType.locationString">Zelf invullen</option>
                                                <option :value="locationType.coordinates">Coordinaten</option>

                                            </select>
                                        </div>


                                    </div>
                                    <div class="invalid-feedback">
                                        <div v-if="errors.CurrentLocationId">
                                            {{ errors.CurrentLocationId.join(', \n') }}
                                        </div>
                                    </div>
                                    <div class="invalid-feedback">
                                        <div v-if="errors.CurrentLocationString">
                                            {{ errors.CurrentLocationString.join(', \n') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label v-if="material.equipmentGroup == equipmentGroup.Material" for="name">
                                        Afmetingen
                                        <span class="required">*</span>
                                    </label>
                                    <label v-if="material.equipmentGroup == equipmentGroup.Equipment" for="name">
                                        Afmetingen
                                    </label>
                                    <input id="name" type="text" class="form-control" name="name"
                                        v-model="material.dimensions" />
                                    <div class="invalid-feedback">
                                        <div v-if="errors.Dimensions">{{ errors.Dimensions.join(', \n') }}</div>
                                    </div>
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Material" class="col-md-6">
                                    <label for="material">Materiaal</label>
                                    <input id="material" type="text" class="form-control" name="material"
                                        v-model="material.material" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Material" class="col-md-6">
                                    <label for="comment">Opmerking</label>
                                    <input id="comment" type="text" class="form-control" name="comment"
                                        v-model="material.comment" />
                                </div>
                                <div class="col-md-6">
                                    <label for="locationId">
                                        Standplaats
                                        <span class="required">*</span>
                                    </label>
                                    <select id="locationId" class="form-select" name="locationId"
                                        v-model="material.locationId">
                                        <option v-for="location in locations" :key="location.id" :value="location.id"
                                            :disabled="location.id == this.material.locationId">
                                            {{ location.name }}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback">
                                        <div v-if="errors.LocationId">{{ errors.LocationId.join(', \n') }}</div>
                                    </div>
                                </div>

                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="disposal">
                                        Afvoer (M
                                        <sup>3</sup>
                                        /U)
                                    </label>
                                    <input id="disposal" type="number" class="form-control" name="disposal"
                                        v-model="material.disposal" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="suctionHose">Zuigslang (M)</label>
                                    <input id="suctionHose" type="number" class="form-control" name="suctionHose"
                                        v-model="material.suctionHose" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="drainHose">Afvoerslang (M)</label>
                                    <input id="drainHose" type="number" class="form-control" name="drainHose"
                                        v-model="material.drainHose" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="power">Vermogen</label>
                                    <input id="power" type="number" class="form-control" name="power"
                                        v-model="material.power" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="curves">Bochten</label>
                                    <input id="curves" type="text" class="form-control" name="curves"
                                        v-model="material.curves" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="fuel">Brandstof</label>
                                    <select id="fuel" class="form-select" name="fuel" v-model="material.fuel">
                                        <option selected :value=null disabled>Kies brandstof</option>
                                        <option selected value="" disabled style="display:none;"></option>
                                        <option value="">Geen</option>
                                        <option value=0>Benzine</option>
                                        <option value=1>Diesel</option>
                                        <option value=2>Diesel Euro-6</option>
                                    </select>
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="comment">Overige specificaties</label>
                                    <input id="comment" type="text" class="form-control" name="comment"
                                        v-model="material.comment" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="stationary">Stationair</label>
                                    <input id="stationary" type="checkbox" name="stationary"
                                        v-model="material.stationary" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="transportByTrailer">Vervoer via aanhanger</label>
                                    <input id="transportByTrailer" type="checkbox" name="transportByTrailer"
                                        v-model="material.transportByTrailer" />
                                </div>
                                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                                    <label for="electricalConnection">Elektrische aansluiting</label>
                                    <input id="electricalConnection" type="checkbox" name="electricalConnection"
                                        v-model="material.electricalConnection" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showDeletePopup" class="popup-overlay">
                <div class="popup-content">
                    <h4>
                        Weet je zeker dat je dit materiaal
                        <br />
                        of materieel wilt verwijderen?
                    </h4>
                    <hr />
                    <div class="popup-actions">
                        <button @click="closePopup" class="btn btn-gray" type="button">Annuleren</button>
                        <button @click="deleteEmergencyEquipment" class="btn btn-danger" type="button">
                            Verwijderen
                        </button>
                    </div>
                </div>
            </div>

            <div class="actions">
                <button type="button" @click="showPopup" class="btn btn-danger ms-4">Verwijderen</button>
                <router-link :to="{ name: 'EmergencyEquipmentOverview' }" class="btn btn-gray">Annuleren</router-link>
                <button type="submit" class="btn btn-primary-dark ms-3">Opslaan</button>
            </div>
        </form>

        <div class="card cardrow">
            <div class="card-body">
                <div class="top-bar">
                    <h5>Geschiedenis</h5>
                </div>

                <div class="overview-list">
                    <table class="table">
                        <thead>
                            <tr>
                                <td>Status</td>
                                <td>Locatie</td>
                                <td>Onder naam</td>
                                <td>Datum</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="history in this.materialHistory" v-bind:key="history.id">
                                <td>{{ this.statusEnum[history.status] }}</td>
                                <td>{{ displayCorrectLocation(history.locationName, history.locationString,
                                    history.longitude, history.latitude) }}</td>
                                <td>{{ history.inUseByName }}</td>
                                <td>{{ formatDateToLong(history.changedOn) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <Pagination v-if="this.material.historyCount" :currentPage="this.currentHistoryPage"
            :totalPages="this.material.historyCount" @pagechanged="changePage"></Pagination>
    </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Pagination from '@/components/Pagination.vue';
import Status from '@/enums/status.enum.ts';
import formatDateToLong from '@/utils/dateFormatter.ts';
import { displayCorrectLocation, parseCoordinates } from '@/utils/coordinateFormatter';
import { hasFeature } from '@/utils/featureFlagGetter.ts';
import useVuelidate from '@vuelidate/core';

export default {
    components: {
        LoadingSpinner,
        Pagination,
    },
    name: 'EmergencyEquipmentDetail',
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            status: {
                Available: 0,
                InTransit: 1,
                InUse: 2,
                Faulty: 3,
            },
            equipmentGroup: {
                Material: 0,
                Equipment: 1,
            },
            locationType: {
                locationId: 0,
                locationString: 1,
                coordinates: 2
            },
            showDeletePopup: false,
            errors: [],
            isLoading: false,
            equipmentTypes: [],
            locations: [],
            material: {
                typeId: 0,
                typeName: '',
                equipmentGroup: 0,
                status: 0,
                dimensions: '',
                locationId: 0,
                location: '',
                currentLocationId: 0,
                fuel: null,
                suctionHose: 0,
                drainHose: 0,
                qr: new Blob(),
                historyCount: 0,
                usedByUserId: -1,
                currentLocationString: '',
            },
            materialHistory: [],
            currentHistoryPage: 1,
            statusEnum: Status,
            allUsers: [],
            customLocation: false,
            chosenLocationType: 0
        };
    },
    mixins: [formatDateToLong],
    computed: {
        formattedDate() {
            return this.formatDateToLong(this.date);
        }
    },

    mounted() {
        this.getEmergencyEquipmentData();
        this.getEquipmentTypeData();
        this.getLocationData();
        this.getEmergencyEquipmentHistory();
        this.getEmergencyEquipmentQr();
        this.getUsersData();
    },

    methods: {
        displayCorrectLocation,
        parseCoordinates,
        hasFeature,
        changePage(pageNumber) {
            this.currentHistoryPage = pageNumber;
            this.getEmergencyEquipmentHistory();
        },

        getEmergencyEquipmentQr() {
            this.isLoading = true;

            this.$axiosInstance
                .get(`${process.env.VUE_APP_API}/EmergencyEquipment/${this.$route.params.id}/qrcode`, {
                    responseType: 'blob',
                })
                .then(response => {
                    if (response.data) {
                        this.material.qr = URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));
                    }
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Qr code ophalen mislukt. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getEmergencyEquipmentHistory() {
            this.isLoading = true;

            this.$axiosInstance
                .get(`${process.env.VUE_APP_API}/EmergencyEquipment/history`, {
                    params: {
                        Id: this.$route.params.id,
                        Page: this.currentHistoryPage,
                    },
                })
                .then(response => {
                    if (response.data) {
                        this.materialHistory = response.data;
                    }
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Geschiedenis ophalen mislukt. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getEmergencyEquipmentData() {
            this.isLoading = true;
            this.chosenLocationType = this.locationType.locationString;
            this.$axiosInstance
                .get(`${process.env.VUE_APP_API}/EmergencyEquipment/${this.$route.params.id}`)
                .then(response => {
                    if (response.data) {
                        this.material = response.data;
                        if (this.material.currentLocationId != null) {
                            this.chosenLocationType = this.locationType.locationId;
                        } else if (this.material.longitude != null && this.material.latitude != null) {
                            this.chosenLocationType = this.locationType.coordinates
                        }
                    }
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Noodmateriaal ophalen mislukt. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getEquipmentTypeData() {
            this.isLoading = true;

            Promise.all([
                this.$axiosInstance.get(`${process.env.VUE_APP_API}/EmergencyEquipmentType`, {
                    params: {
                        equipmentGroup: this.material.equipmentGroup,
                    },
                }),
            ])
                .then(([equipmentTypes]) => {
                    if (equipmentTypes.data !== '') {
                        this.equipmentTypes = equipmentTypes.data;
                    }
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Basis informatie van noodmaterialen kon niet worden opgehaald.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getLocationData() {
            this.isLoading = true;

            this.$axiosInstance
                .get(`${process.env.VUE_APP_API}/EmergencyEquipmentLocation`)
                .then(response => {
                    if (response.data !== '') {
                        this.locations = response.data;
                    }
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Locaties konden niet worden opgehaald.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getUsersData() {
            this.isLoading = true;

            this.$axiosInstance
                .get(`${process.env.VUE_APP_API}/Users/GetAll`)
                .then(response => {
                    if (response.data !== '') {
                        this.allUsers = response.data;
                    }
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Gebruikers konden niet worden opgehaald.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        updateEmergencyEquipment() {
            this.isLoading = true;
            this.errors = [];
            const updateForm = {
                id: this.material.id,
                equipmentGroup: this.material.equipmentGroup,
                typeId: this.material.typeId,
                dimensions: this.material.dimensions,
                material: this.material.material,
                comment: this.material.comment,
                locationId: this.material.locationId,
                disposal: this.material.disposal,
                suctionHose: this.material.suctionHose,
                drainHose: this.material.drainHose,
                power: this.material.power,
                fuel: this.material.fuel,
                stationary: this.material.stationary,
                transportByTrailer: this.material.transportByTrailer,
                electricalConnection: this.material.electricalConnection,
                extraSpecifications: this.material.extraSpecifications,
                currentLocationId: this.chosenLocationType == this.locationType.locationId ? this.material.currentLocationId : null,
                currentLocationString: this.chosenLocationType == this.locationType.locationString ? this.material.currentLocationString : null,
                longitude: this.chosenLocationType == this.locationType.coordinates ? this.material.longitude : null,
                latitude: this.chosenLocationType == this.locationType.coordinates ? this.material.latitude : null,
                status: this.material.status,
                usedByUserId: this.material.usedByUserId != -1 ? this.material.usedByUserId : null,
            };
            this.$axiosInstance
                .put(`${process.env.VUE_APP_API}/EmergencyEquipment/update`, updateForm)
                .then(response => {
                    if (response.data.status === 400) {
                        this.errors = response.data.errors;
                        this.$toast.open({
                            message: 'Er zijn één of meer validatiefouten opgetreden.',
                            type: 'warning',
                            position: 'top-right',
                            duration: 5000,
                        });
                    } else {
                        this.$toast.open({
                            message: 'Materiaal successvol aangepast!',
                            position: 'top-right',
                            duration: 5000,
                        });
                        this.$router.push({ name: 'EmergencyEquipmentOverview' })
                    }
                })
                .catch(err => {
                    this.errors = err.response.data.errors;
                    this.$toast.open({
                        message: 'Aanpassen mislukt. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        deleteEmergencyEquipment() {
            this.isLoading = true;

            this.$axiosInstance
                .delete(`${process.env.VUE_APP_API}/EmergencyEquipment/${this.$route.params.id}`)
                .then(() => {
                    this.$toast.open({
                        message: 'Materiaal succesvol verwijderd!',
                        position: 'top-right',
                        duration: 5000,
                    });
                    this.$router.push({ name: 'EmergencyEquipmentOverview' });
                })
                .catch(() => {
                    this.$toast.open({
                        message: 'Verwijderen mislukt. Probeer het a.u.b. opnieuw.',
                        type: 'error',
                        position: 'top-right',
                        duration: 5000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                    this.closePopup();
                });
        },

        showPopup() {
            this.showDeletePopup = true;
        },
        closePopup() {
            this.showDeletePopup = false;
        },

        getStatusText(status) {
            switch (status) {
                case this.status.Available:
                    return 'Beschikbaar';
                case this.status.InUse:
                    return 'Bezet';
                case this.status.Faulty:
                    return 'Defect';
                case this.status.InTransit:
                    return 'Onderweg';
                default:
                    return '';
            }
        },

        formSubmit() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.updateEmergencyEquipment();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.top-bar {
    display: flex;
    justify-content: space-between;
}

.qr-code {
    height: 100px;
    width: 100px;
}

.main-header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.invalid-feedback {
    display: block;
}

.actions {
    margin-top: $spacer * 1.5;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: $spacer;

    .btn {
        min-width: 7.5rem;
    }

    .btn-danger {
        margin-right: 16px;
    }
}

.row {
    margin-bottom: $spacer;
}

.cardrow {
    margin-bottom: $spacer;
}

.card-body label {
    width: 100%;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-content {
    background: white;
    padding: 35px;
    border-radius: 5px;
    text-align: center;
}

.popup-actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
}

.form-checkbox {
    margin-top: 0 !important;
}

.flex-box {
    display: flex;
    justify-content: space-between;
    gap: 5px;
    white-space: nowrap;
    align-items: center;
}

.flex-stretch {
    flex: 1;
}
</style>
